export const CLASSES_GET_CLASSES = 'CLASSES_GET_CLASSES';
export const CLASSES_GET_CLASSES_SUCCESS = 'CLASSES_GET_CLASSES_SUCCESS';
export const CLASSES_GET_CLASSES_FAILURE = 'CLASSES_GET_CLASSES_FAILURE';

export const CLASSES_CREATE_CLASSES = 'CLASSES_CREATE_CLASSES';
export const CLASSES_CREATE_CLASSES_SUCCESS = 'CLASSES_CREATE_CLASSES_SUCCESS';
export const CLASSES_CREATE_CLASSES_FAILURE = 'CLASSES_CREATE_CLASSES_FAILURE';

export const CLASSES_EDIT_CLASSES = 'CLASSES_EDIT_CLASSES';
export const CLASSES_EDIT_CLASSES_SUCCESS = 'CLASSES_EDIT_CLASSES_SUCCESS';
export const CLASSES_EDIT_CLASSES_FAILURE = 'CLASSES_EDIT_CLASSES_FAILURE';

export const CLASSES_REMOVE_CLASSES = 'CLASSES_REMOVE_CLASSES';
export const CLASSES_REMOVE_CLASSES_SUCCESS = 'CLASSES_REMOVE_CLASSES_SUCCESS';
export const CLASSES_REMOVE_CLASSES_FAILURE = 'CLASSES_REMOVE_CLASSES_FAILURE';

export const CLASSES_PROPS_CHANGED = 'CLASSES_PROPS_CHANGED';